enum TaskBarSize {
  Default,
  Large,
}

export default TaskBarSize;
